
import React from 'react'
import { translate } from 'react-i18next'
import { AppStore, UIStore } from '../../../../stores'
import { Button } from '../../../'
import { capitalize } from '../../../../utils'

/**
 *
 */
const OrderLoginErrorAlert = ({ t, ...props }) => <div className="empty-cart-alert">
  <div className="container">
    <div className="row">
      <p className="p light white s12">Parece que su cuenta vinculada no está actualizada. Por favor, compruebe sus datos e inténtelo de nuevo.</p>
    </div>
    <div className="row">
      <p className="p regular white s14">Revisar los datos de mi cuenta de { capitalize(AppStore.providername) }</p>
      <ul>
        <li><Button placeholder="Cerrar" type="flat" color="dark-white" onClick={ props.onCancel } /></li>
        <li><Button placeholder="Revisar" type="flat" color="blue" onClick={ props.onConfirm } /></li>
      </ul>
    </div>
  </div>
</div>

export default translate(['common'], { wait: false })(OrderLoginErrorAlert)
